import * as React from 'react';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { useAccountDetails } from './hooks';
import { Content } from './Content';
import * as Styled from './styled';
import { Retry, Footer } from '@src/components/common';

const AccountDetailsPage = () => {
  const mode = CURRENT_PRODUCT_MODE.toLocaleLowerCase();
  const { data, isLoading, isError, refetch } = useAccountDetails(mode);

  return (
    <Styled.Container>
      <Retry isLoading={isLoading} fetchData={refetch} showError={isError}>
        <Content data={data} />
      </Retry>
      <Footer />
    </Styled.Container>
  );
};

export default AccountDetailsPage;
